export const borders = {
  defaultBorder: "1px solid",
  defaultBoxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.72)",
};
